import React, {Component} from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Row,
  Col,
  Label,
  Button,
  Input,
  InputGroup,
  Tooltip
} from "reactstrap";
import LaddaButton, {ZOOM_OUT} from "react-ladda";
import api from 'api';
import PropTypes from 'prop-types';

class ContactButton extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      sending: false,
      tooltipOpen: false,
      errors: {},
      data: {
        email: '',
        subject: '',
        content: '',
        copy: false,
      }
    };

    this.toggle = this.toggle.bind(this);
    this.send = this.send.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  toggle(property) {
    this.setState({[property]: !this.state[property]});
  }

  send() {
    this.setState({sending: true, errors: {}});

    api.survey.post.contact(this.props.surveyId, this.state.data)
      .then(() => {
        this.setState({errors: {}, sending: false, modal: false});
      })
      .catch(e => {
        this.setState({errors: e.response.data.form.errors, sending: false});
      })
  }

  onChange(e) {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value
      }
    })
  }

  render() {
    const {modal, sending, data, errors, tooltipOpen} = this.state;

    const contactModal = <Modal zIndex={99999} isOpen={modal} size="lg" toggle={() => this.toggle('modal')}>
      <ModalHeader toggle={() => this.toggle('modal')} tag="h5">Kontakt z właścicielem ankiety</ModalHeader>
      <hr className="my-0" />
      <ModalBody>
        <Form onSubmit={this.onSubmit} className="needs-validation">
          <Row className="mb-3">
            <Col md={3}>
              <Label data-role="label" for="email">Email</Label>
            </Col>
            <Col md={9}>
              <Input type="email" id="email" name="email" className="custom" placeholder='Twój adres email' value={data.email} invalid={!!errors.email} onChange={this.onChange}/>
              {errors.email && <div className="invalid-feedback">{errors.email.join('; ')}</div>}
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={3}>
              <Label data-role="label" for="subject">Temat</Label>
            </Col>
            <Col md={9}>
              <Input type="text" id="subject" name="subject" className="custom" placeholder='Temat wiadomości' value={data.subject} invalid={!!errors.subject} onChange={this.onChange}/>
              {errors.subject && <div className="invalid-feedback">{errors.subject.join('; ')}</div>}
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={3}>
              <Label data-role="label" for="content">Wiadomość</Label>
            </Col>
            <Col md={9}>
              <Input type="textarea" id="content" name="content" className="custom" placeholder='Treść wiadomości' value={data.content} invalid={!!errors.content} onChange={this.onChange} rows="5"/>
              {errors.content && <div className="invalid-feedback">{errors.content.join('; ')}</div>}
            </Col>
          </Row>
          <Row>
            <InputGroup className="ml-5">
              <span><Input type="checkbox" id="copy" name="copy" onChange={() => this.onChange({target: {name: 'copy', value: !this.state.data.copy}})} checked={data.copy} />Wyślij kopię do mnie</span>
            </InputGroup>
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={() => this.toggle('modal')}>Anuluj</Button>
          <LaddaButton
            className="btn btn-success btn-ladda"
            loading={sending}
            data-style={ZOOM_OUT}
            onClick={this.send}
          >
            Wyślij
          </LaddaButton>
      </ModalFooter>
    </Modal>;

    return (
      <div onClick={() => this.toggle('modal')} className="d-inline-block pointer" id={"contactWithAuthor"}>
        <Tooltip
            target={"contactWithAuthor"}
            isOpen={tooltipOpen}
            toggle={() => this.setState({tooltipOpen: !tooltipOpen})}
        >Kontakt z autorem ankiety</Tooltip>
        <i className="fas fa-envelope"/> {this.props.showText && <span className={"d-inline-block d-lg-none"}>Kontakt z autorem ankiety</span>}
        {contactModal}
      </div>
    )
  }
}

ContactButton.defaultProps = {
  showText: true
};

ContactButton.propTypes = {
  surveyId: PropTypes.number.isRequired,
  showText: PropTypes.bool.isRequired
};

export default ContactButton;